import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { SpinnerService } from './spinner.service';
import { Observable } from 'rxjs';
import { map, finalize, catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromReducer from './../state/reducers';
import * as fromLoggerAction from './../state/actions/logger.actions';
import * as toastActions from './../../shared/state/actions/toast.actions';
import { getError } from '../Utility/ErrorMessage';
import { Type } from '../toast/model/toast';
@Injectable({
  providedIn: 'root'
})
export class AppBaseHttpService {

  constructor(private http: HttpClient,
    private spinnerService: SpinnerService,
    private store: Store<fromReducer.State>
  ) { }

  get<T>(url: string, showSpinner: boolean = true): Observable<T> {
    if (showSpinner) {
      this.spinnerService.show();
    }
    return this.http.get(url).pipe(
      map((data: T) => data),
      catchError((error: HttpErrorResponse) => {
        if (error.status != HttpStatusCode.Unauthorized) {
          this.store.dispatch(fromLoggerAction.Exception({ error: error }));
          this.store.dispatch(toastActions.Show({ toast: { header: "ATS Error", message: getError(error), type: Type.Error } }));
        }
        throw error;
      }),
      finalize(() => this.spinnerService.hide())
    );
  }

  post<T>(url: string, data: any, showSpinner: boolean = true): Observable<T> {
    if (showSpinner) {
      this.spinnerService.show();
    }
    return this.http.post(url, data).pipe(
      map((data: T) => data),
      catchError((error: HttpErrorResponse) => {
        if (error.status != HttpStatusCode.Unauthorized) {
          this.store.dispatch(fromLoggerAction.Exception({ error: error }));
          this.store.dispatch(toastActions.Show({ toast: { header: "ATS Error", message: getError(error), type: Type.Error } }));
        }
        throw error;
      }),
      finalize(() => this.spinnerService.hide())
    )
  }

  postFile<T>(url: string, file: File, showSpinner: boolean = true): Observable<T> {
    if (showSpinner) {
      this.spinnerService.show();
    }

    let formData: FormData = new FormData();
    if (file != null) {
      formData.append(file.name, file, file.name);
    }
    return this.http.post(url, formData).pipe(
      map((data: T) => data),
      catchError((error: HttpErrorResponse) => {
        if (error.status != HttpStatusCode.Unauthorized) {
          this.store.dispatch(fromLoggerAction.Exception({ error: error }))
          //this.store.dispatch(toastActions.Show({ toast: { header: "ATS Error", message: getError(error), type: Type.Error } }));
        }
        throw error;
      }),
      finalize(() => this.spinnerService.hide())
    )
  }

  postFileAndData<T>(url: string, file: File, data: any, showSpinner: boolean = true): Observable<T> {
    if (showSpinner) {
      this.spinnerService.show();
    }

    let formData: FormData = new FormData();
    if (file != null) {
      formData.append(file.name, file, file.name);
    }
    if (data != null) {
      formData.append('data', JSON.stringify(data));
    }
    return this.http.post(url, formData).pipe(
      map((data: T) => data),
      catchError((error: HttpErrorResponse) => {
        if (error.status != HttpStatusCode.Unauthorized) {
          this.store.dispatch(fromLoggerAction.Exception({ error: error }))
          this.store.dispatch(toastActions.Show({ toast: { header: "ATS Error", message: getError(error), type: Type.Error } }));
        }
        throw error;
      }),
      finalize(() => this.spinnerService.hide())
    )
  }

  downloadDocumentGet(url: string, showSpinner: boolean = true): any {

    if (showSpinner) {
      this.spinnerService.show();
    }

    return this.http.get(url, { responseType: 'blob' }).pipe(
      map((res) => { return res }),
      catchError((error: HttpErrorResponse) => {
        if (error.status != HttpStatusCode.Unauthorized) {
          this.store.dispatch(fromLoggerAction.Exception({ error: error }));
          this.store.dispatch(toastActions.Show({ toast: { header: "ATS Error", message: getError(error), type: Type.Error } }));
        }
        throw error;
      }),
      finalize(() => this.spinnerService.hide())
    );
  }

  downloadDocumentPost(url: string, data:any, showSpinner: boolean = true): any {

    if (showSpinner) {
      this.spinnerService.show();
    }

    return this.http.post(url, data, { responseType: 'blob' }).pipe(
      map((res) => { return res }),
      catchError((error: HttpErrorResponse) => {
        if (error.status != HttpStatusCode.Unauthorized) {
          this.store.dispatch(fromLoggerAction.Exception({ error: error }));
          this.store.dispatch(toastActions.Show({ toast: { header: "ATS Error", message: getError(error), type: Type.Error } }));
        }
        throw error;
      }),
      finalize(() => this.spinnerService.hide())
    );
  }



}
